var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.models.length)?_c('b-row',[_c('b-col',[_c('div',{staticClass:"j-between"},[_c('h3',{staticClass:"text-left"},[_c('strong',[_vm._v(" Total: "+_vm._s(_vm.price(_vm.total))+" ")])]),_c('h4',[_vm._v(" Unidades vendidas: "+_vm._s(_vm.unidades_vendidas)+" ")])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }